import { createAction } from '@reduxjs/toolkit'

/** Команды доставки каталога — plain actions (F05); исполняет их listener. */
export const deliveryReloadRequested = createAction<{ resourceId: string }>('aqsi/delivery/reloadRequested')
export const deliveryReconcileRequested = createAction<{ resourceId: string }>('aqsi/delivery/reconcileRequested')
